"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferOrderLineChanges = void 0;
const dayjs = require("dayjs");
const pluralize_1 = require("../pluralize");
const getTransferOrderLineChanges = (previous, current) => {
    const changed_items = [];
    const changes = {};
    // Check if date has changed
    if (previous.where_when_who.date !== current.where_when_who.date) {
        changed_items.push("Date of play");
        changes.date = {
            has_changed: true,
            previous_value: dayjs(previous.where_when_who.date).format("ddd, Do MMM YYYY"),
        };
    }
    // from address changed?
    if (previous.transfer_legs.outbound.from_area !==
        current.transfer_legs.outbound.from_area) {
        changed_items.push("From");
        changes.from = {
            has_changed: true,
            previous_value: previous.transfer_legs.outbound.from_area,
        };
    }
    // pickup address changed?
    // drop address changed?
    // Check if date has changed
    if (previous.where_when_who.type !== current.where_when_who.type) {
        changed_items.push("Transfer Type");
        changes.date = {
            has_changed: true,
            previous_value: previous.where_when_who.type,
        };
    }
    // Check if date has changed
    if (previous.where_when_who.pickup_name !== current.where_when_who.pickup_name) {
        changed_items.push("Pick-up Name");
        changes.pickup_name = {
            has_changed: true,
            previous_value: previous.where_when_who.pickup_name,
        };
    }
    // has the number of passengers changed?
    if (previous.vehicle.vehicle?.id !== current.vehicle.vehicle?.id) {
        changed_items.push("Vehicle");
        changes.vehicle = {
            has_changed: true,
            previous_value: `${previous.vehicle.quantity} X ${previous.vehicle.vehicle?.name.en})`,
        };
    }
    // has the number of passengers changed?
    if (previous.where_when_who.number_of_passengers !==
        current.where_when_who.number_of_passengers) {
        changed_items.push("No. of Passengers");
        changes.passengers = {
            has_changed: true,
            previous_value: (0, pluralize_1.pluralize)(previous.where_when_who.number_of_passengers, "Pax", "Pax"),
        };
    }
    return {
        ...changes,
        changes: changed_items,
    };
};
exports.getTransferOrderLineChanges = getTransferOrderLineChanges;
